import type { CSSProperties } from "react";

import type { ProfissionaisColumnKey } from "./types-profissionais";

export const PROFISSIONAIS_SAVED_FILTERS_SCREEN = "profissionais";
export const PROFISSIONAIS_SEARCH_PLACEHOLDER = "Buscar nome, time...";
export const UNAVAILABLE_LABEL = "Indisponível";
export const PROFISSIONAIS_LOADING_LABEL = "Carregando profissionais...";
export const PROFISSIONAIS_TABLE_LABEL = "Profissionais";

export const PROFISSIONAIS_EXPORT_FILE_NAME = "profissionais";
export const PROFISSIONAIS_EXPORT_LIST_NAME = "profissionais";

export const PROFISSIONAIS_EMPTY_NOUN = "profissional";
export const PROFISSIONAIS_EMPTY_PLURAL = "profissionais";

export const PROFISSIONAIS_COLUMNS: readonly {
  key: ProfissionaisColumnKey;
  header: string;
  style: CSSProperties;
  sortable: boolean;
}[] = [
  { key: "nome", header: "Profissional", style: { minWidth: "16rem" }, sortable: true },
  {
    key: "telefone",
    header: "Telefone",
    style: { width: "12rem", minWidth: "12rem", whiteSpace: "nowrap" },
    sortable: true,
  },
  { key: "cargo", header: "Cargo", style: { width: "8rem" }, sortable: true },
  { key: "time", header: "Time", style: { width: "8rem" }, sortable: true },
  // O core não ordena por indisponibilidade.
  {
    key: "indisponibilidade",
    header: "Indisponibilidade no Período",
    style: { minWidth: "12rem" },
    sortable: false,
  },
];

// RN07: sem mostrar/ocultar colunas; todas ficam sempre visíveis.
export const PROFISSIONAIS_COLUMN_KEYS: readonly ProfissionaisColumnKey[] =
  PROFISSIONAIS_COLUMNS.map((column) => column.key);

export const PROFISSIONAIS_ROWS_PER_PAGE_LABEL = "Profissionais por página";
